import request from '../http';

// 获取素材列表
export const listMaterials = (params) =>
  request({ url: '/material/materials', method: 'get', params });

// 获取素材详情（支持 startDate/endDate 消耗统计日期范围）
export const getMaterial = (id, params) =>
  request({ url: `/material/materials/${id}`, method: 'get', params });

// 查询素材每日消耗明细（趋势图/明细表用）
export const getConsumptionDaily = (id, params) =>
  request({ url: `/material/materials/${id}/consumption-daily`, method: 'get', params });

// 查询素材引用明细（options.folderId 非空时仅返回该文件夹下的引用，与列表视图一致）
export const getMaterialFolderReferences = (id, options = {}) => {
  const { folderId, ...rest } = options;
  const params = {};
  if (folderId != null && folderId > 0) params.folderId = folderId;
  return request({ url: `/material/materials/${id}/folder-references`, method: 'get', params, ...rest });
};

// 上传素材（skipErrorMessage=true：重复等业务错误由调用方自行处理，避免全局弹窗）
export const uploadMaterial = (data, extraConfig = {}) => {
  const { headers, ...restConfig } = extraConfig || {};
  return request({
    url: '/material/materials',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
      ...(headers || {})
    },
    timeout: 0,
    skipErrorMessage: true,
    ...restConfig
  });
};

// 批量校验文件名是否已在库中存在
export const checkMaterialNames = (fileNames, folderId) =>
  request({ url: '/material/materials/check-names', method: 'post', data: { fileNames, folderId } });

// 复用已存在素材：关联到当前目录并追加标签
export const reuseExistingMaterials = (materialIds, folderId, tagIds) =>
  request({ url: '/material/materials/reuse-existing', method: 'post', data: { materialIds, folderId, tagIds } });

// 更新素材信息
export const updateMaterial = (id, data) =>
  request({ url: `/material/materials/${id}`, method: 'put', data });

// 删除素材
export const deleteMaterial = (id) =>
  request({ url: `/material/materials/${id}`, method: 'delete' });

// 批量删除素材
export const batchDeleteMaterials = (ids) =>
  request({ url: '/material/materials/batch', method: 'delete', data: { ids } });

// 更新素材标签
export const updateMaterialTags = (id, tagIds) =>
  request({ url: `/material/materials/${id}/tags`, method: 'put', data: { tagIds } });

// 批量更新素材所属文件夹
export const batchUpdateMaterialFolder = (ids, folderId) =>
  request({ url: '/material/materials/batch/folder', method: 'put', data: { ids, folderId } });

// 从指定文件夹移除素材引用（仅解除关联，不软删除素材；无投放引用校验）
export const batchRemoveFromFolder = (ids, folderId) =>
  request({ url: '/material/materials/batch/remove-from-folder', method: 'post', data: { ids, folderId } });

// 批量为素材打标签（追加）
export const batchAddMaterialTags = (ids, tagIds, mode) =>
  request({ url: '/material/materials/batch/tags', method: 'put', data: { ids, tagIds, mode } });

/**
 * 下载素材为 ZIP（同步流式，易超时）
 * @deprecated 建议使用 createDownloadTask 异步方式
 */
export const downloadMaterialsZip = (params) =>
  request({
    url: '/material/materials/download-zip',
    method: 'post',
    data: params,
    responseType: 'blob',
    timeout: 0
  });

/** 预览下载数量（文件夹名、数量、总素材数） */
export const getDownloadPreview = (params) =>
  request({ url: '/material/materials/download-preview', method: 'get', params });

/** 创建下载任务（异步打包，立即返回） */
export const createDownloadTask = (data) =>
  request({ url: '/material/download-tasks', method: 'post', data });

/**
 * 分页查询下载任务列表
 * @param {object} params pageNo/pageSize
 * @param {object} [config] 可传 skipErrorMessage，供轮询静默失败
 */
export const listDownloadTasks = (params, config = {}) =>
  request({ url: '/material/download-tasks', method: 'get', params, ...config });

// ----  COS 直传相关（供插件 / 需要直传场景使用）----

/**
 * 获取 COS POST Object 直传签名
 * 返回：{ cosHost, dir, policy, qSignAlgorithm, qAk, qKeyTime, qSignature, success_action_status }
 * @param {number|null} folderId 上传完成后关联的文件夹 ID（可选）
 */
export const getUploadSignature = (folderId) =>
  request({
    url: '/system/fileInfo/getUploadSignature',
    method: 'get',
    params: folderId != null ? { folderId } : {}
  });

/**
 * COS 直传回调：通知后端保存素材记录
 * @param {Array<{fileName, originalName, filePath, fileUrl, fileSize, fileType, folderId, thumbnailPath}>} fileInfoList
 */
export const uploadCallbackCos = (fileInfoList) =>
  request({
    url: '/system/fileInfo/uploadCallback',
    method: 'post',
    data: fileInfoList
  });

/**
 * 下载任务 ZIP：拼浏览器原生下载地址（带 access_token）。
 * 不要用 axios blob：会把整包缓冲进内存，大 ZIP 会转圈数分钟且下载栏无动静。
 */
export const buildDownloadTaskFileUrl = (id) => {
  const token = localStorage.getItem('token') || '';
  const base = process.env.VUE_APP_BASE_API || '/api';
  const root = String(base).replace(/\/$/, '');
  return `${root}/material/download-tasks/${id}/file?access_token=${encodeURIComponent(token)}`;
};

/** @deprecated 请用 buildDownloadTaskFileUrl + 原生 <a> 下载 */
export const downloadTaskFile = (id) =>
  request({
    url: `/material/download-tasks/${id}/file`,
    method: 'get',
    responseType: 'blob',
    timeout: 0
  });
